import * as React from 'react';
import { styled } from '@mui/system';
import NoteCardsTitle from '../NoteCardsTitle';
import NoteCard from '../NoteCard';
import NoteTabsGroup from '../NoteTabsGroup';
import NoteCardsSection from '../NoteCardsSection';

// gap -> padding

const NoteContentsDisplay = styled('div')({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const NotesCardGroup = ({
  noteCardData,
  savedNotesData,
  displayName,
  typeofTitle,
  isOwnerTabs,
}) => {
  // console.log(`${isOwnerTabs ? 'owner' : 'not owner'}`);
  return (
    <NoteContentsDisplay>
      {isOwnerTabs ? (
        <NoteTabsGroup postedNotesData={noteCardData} savedNotesData={savedNotesData} />
      ) : (
        <>
          <NoteCardsTitle typeofTitle={typeofTitle} displayName={displayName} />
          <NoteCardsSection>
            {noteCardData.map((data, key) => (
              <NoteCard key={key} {...data} />
            ))}
          </NoteCardsSection>
        </>
      )}
    </NoteContentsDisplay>
  );
};

export default NotesCardGroup;
